import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import InfoBar from "containers/TestResultsInfoBar";
import { LoaderButton } from "ctia-ui";
import TestResultPanel from "components/TestResultPanel";
import PageTitle from "containers/request/Initial/RequestPageTitle";
import LabResultForm from "containers/testResult/LabResultForm";
import LabResultUpload from "containers/testResult/LabResultUpload";
import UnderReviewView from "containers/testResult/UnderReviewView";
import {
  hasPreparedResults,
  isResultNoTesting,
  isComplete
} from "helpers/RequestTestsHelper";
import { truncateStr } from "helpers/StringHelper";
import {
  fetchRequest,
  clearRequest,
  saveRequest,
  updateRequest,
  updateDeviceModel
} from "actions/request";
import { startPreloader, finishPreloader } from "actions/preloader";
import {
  fetchRequestTests,
  sendTestResult,
  fetchTestReports
} from "actions/tests";

class TestResultsItem extends Component {
  constructor(props) {
    super(props);

    this.state = { showContent: false, noTesting: false };
  }
  componentDidMount() {
    this.resetRender();
    this.props.startPreloader().then(this.props.clearRequest);
    this.fetchQueue(this.props.match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    const newId = nextProps.match.params.id;
    if (newId !== this.props.match.params.id) {
      this.props.startPreloader().then(this.props.clearRequest);
      this.fetchQueue(newId);
    }
  }

  componentWillUnmount() {
    this.props.clearRequest();
  }

  resetRender = () => {
    this.setState({ showContent: false });
  };

  activateRender = () => {
    this.setState({ showContent: true });
  };

  fetchQueue = requestId => {
    return this.props
      .fetchRequest(requestId)
      .then(this.fetchTests)
      .then(this.fetchReports)
      .then(this.props.finishPreloader)
      .then(this.activateRender);
  };

  fetchTests = () => {
    return this.props.fetchRequestTests(this.props.match.params.id);
  };

  fetchReports = response => {
    const resData = response.payload.data;
    if (!resData) return null;

    const testId = resData.data[0].id;
    return this.props.fetchTestReports(testId);
  };

  onValidate() {
    const { request, tests } = this.props;
    const {
      testResults,
      hwVersion,
      swVersion,
      isCBSDDPdevice,
      dpSwVersion
    } = request;
    const {
      reports,
      planversion,
      requesttestpassedstatusid
      // requesttestconductinglabs
    } = tests[0];

    // validate `CBSD + DP` request type
    const cbsdValidate = isCBSDDPdevice ? String(dpSwVersion) !== "" : true;

    const commonFieldsValidate =
      Number(requesttestpassedstatusid) > 0 &&
      String(planversion).trim() !== "" &&
      String(hwVersion).trim() !== "" &&
      String(swVersion).trim() !== "" &&
      cbsdValidate;

    if (!commonFieldsValidate) return false;

    if (isResultNoTesting(requesttestpassedstatusid)) return true;

    return (
      // requesttestconductinglabs.length > 0 &&
      hasPreparedResults(testResults) || reports.length
    );
  }

  onSubmit = () => {
    const {
      sendTestResult,
      tests,
      startPreloader,
      finishPreloader
    } = this.props;

    startPreloader();

    // update dates, plan version and test result
    sendTestResult(tests[0])
      .then(this.updateRequestFields)
      .then(this.updateDeviceModelInfo)
      .then(this.uploadTestReports)
      .then(finishPreloader);
  };

  updateRequestFields = () => {
    const { request, updateRequest } = this.props;
    const { id, hwVersion, swVersion, dpSwVersion } = request;
    const requestInfo = {
      id,
      hwVersion: truncateStr(hwVersion),
      swVersion: truncateStr(swVersion),
      dpSwVersion: truncateStr(dpSwVersion)
    };

    // update hw/sw for the request
    return updateRequest(requestInfo);
  };

  updateDeviceModelInfo = () => {
    const { request, updateDeviceModel } = this.props;
    // const { fccId } = request;

    // if no FCC ID was entered by lab, we don't need to save it
    // if (String(fccId).length === 0) return Promise.resolve(true);

    // update fccid for the device model
    return updateDeviceModel(request.model.id, {
      fccid: _.trim(request.fccId)
    });
  };

  uploadTestReports = () => {
    // upload test reports
    this.props.saveRequest(() => {});
  };

  onDone = () => {
    this.props.history.push("/lab/results");
  };

  onHandleTestingResult = value => {
    this.setState({ noTesting: value });
  };

  render() {
    const { request, tests } = this.props;

    if (_.isNull(request) || _.isNull(tests) || !request.id) {
      return null;
    }

    if (!this.state.showContent) return null;

    if (request.formSaved) {
      return (
        <div>
          <h1 style={{ paddingBottom: 15 }}>Uploading Test Results</h1>
          <TestResultPanel />
          <LoaderButton text="Done" onClick={this.onDone} disabled={false} />
        </div>
      );
    }

    const testModule = tests[0];
    const completed = isComplete(testModule.requestteststatusid);

    return (
      <div>
        <Link to="/lab/results">
          <LoaderButton text="&larr; Return to list" />
        </Link>
        <PageTitle />
        <InfoBar />
        <UnderReviewView show={completed} testModule={testModule} />
        <LabResultForm
          show={!completed}
          testModule={testModule}
          handleTestResult={this.onHandleTestingResult}
        />
        <LabResultUpload show={!completed && !this.state.noTesting} />
        <Row>
          <Col className="text-center">
            <LoaderButton
              bsStyle="info"
              text="Save changes"
              loadingText="Uploading..."
              onClick={this.onSubmit}
              isLoading={request.isLoading}
              disabled={!this.onValidate()}
              show={!completed}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps({ request, tests }) {
  return { request, tests };
}

export default connect(mapStateToProps, {
  fetchRequest,
  sendTestResult,
  clearRequest,
  fetchRequestTests,
  startPreloader,
  finishPreloader,
  saveRequest,
  fetchTestReports,
  updateRequest,
  updateDeviceModel
})(TestResultsItem);



// WEBPACK FOOTER //
// ./src/containers/TestResultsItem.js